import { useContext } from "react";
import { closeIcon } from "../../../assets/icons";
import { OptionDt } from "../../../Models/SearchModel";
import { SearchContext } from "../../../Store/Search.store";
import styles from "./activeSearchFilter.module.css";
export default function ActiveFilterButton({item, filter, filterOrder, clearFilter}: {item: OptionDt, filter: string, filterOrder: number, clearFilter: (filter: OptionDt[], filterOrder: number) => void}) {
    const { searchData } = useContext(SearchContext);
    const clearCurrentFilter = () => {
        let filter = [] as OptionDt[];
        switch (filterOrder) {
            case 1:
                filter = searchData.data.filters.alternativeToCategories;
                break;
            case 2:
                filter = searchData.data.filters.sectorCategories;
                break;
            case 3:
                filter = searchData.data.filters.useCategories;
                break;
            case 4:
                filter = searchData.data.filters.alternativeLevels;
                break;
            case 5:
                filter = searchData.data.filters.suppliers;
                break;
            case 6:
                filter = searchData.data.filters.certificationsCategories;
                break;
            default:
        }

        const selectedFilters = filter.filter(item => item.isSelected);
        const newFilterState = selectedFilters.filter(filter => filter.id !== item.id);

        clearFilter(newFilterState, filterOrder);
    }
    return (
        <div className={styles.active_filter} id={item.name + "_" + item.id}>
            <span>
            {filter}: {item.name}
            </span>
            <button aria-label={"remove " + item.name} onClick={clearCurrentFilter}>
            {closeIcon}
            </button>
        </div>
    )
}